import { useEffect, useState } from "react";

/**
 * True when hover-to-open for collapsed nav dropdowns is safe:
 * desktop breakpoint and fine pointer (not touch-primary).
 */
export function useHoverOpenNavDropdown() {
  const [hoverOpen, setHoverOpen] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px) and (pointer: fine)");
    const sync = () => setHoverOpen(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);

  return hoverOpen;
}
